import { defineMessages } from 'react-intl';

/** The copy of the revision history, Compare and "Make a new revision" (Releases v2, design d1–d5). */
export const revisionMessages = defineMessages({
  title: { id: 'app.sml.promote.revisions.title', defaultMessage: 'Revisions' },
  titleCount: { id: 'app.sml.promote.revisions.titleCount', defaultMessage: 'Revisions {count}' },
  number: { id: 'app.sml.promote.revisions.number', defaultMessage: 'r{number}' },
  stateReady: { id: 'app.sml.promote.revisions.state.ready', defaultMessage: 'Ready' },
  stateFailed: { id: 'app.sml.promote.revisions.state.failed', defaultMessage: 'Failed' },
  stateWorking: { id: 'app.sml.promote.revisions.state.working', defaultMessage: 'Working · {percent} %' },
  stateFileRemoved: { id: 'app.sml.promote.revisions.state.fileRemoved', defaultMessage: 'File removed' },
  open: { id: 'app.sml.promote.revisions.open', defaultMessage: 'Open' },
  openNow: { id: 'app.sml.promote.revisions.openNow', defaultMessage: 'Open now' },
  download: { id: 'app.sml.promote.revisions.download', defaultMessage: 'Download' },
  compare: { id: 'app.sml.promote.revisions.compare', defaultMessage: 'Compare' },
  compareTwo: { id: 'app.sml.promote.revisions.compareTwo', defaultMessage: 'Compare two' },
  tryAgainAs: { id: 'app.sml.promote.revisions.tryAgainAs', defaultMessage: 'Try again as r{number}' },
  makeAgainAs: { id: 'app.sml.promote.revisions.makeAgainAs', defaultMessage: 'Make it again as r{number}' },
  newRevision: { id: 'app.sml.promote.revisions.newRevision', defaultMessage: 'New revision' },
  you: { id: 'app.sml.promote.revisions.you', defaultMessage: 'You' },
  unknownMaker: { id: 'app.sml.promote.revisions.unknownMaker', defaultMessage: 'MUSIC24' },
  makerAt: { id: 'app.sml.promote.revisions.makerAt', defaultMessage: '{maker} · {date}' },
  failedNoFile: { id: 'app.sml.promote.revisions.failedNoFile', defaultMessage: 'The render failed. It made no file.' },
  fileRemoved: {
    id: 'app.sml.promote.revisions.fileRemoved',
    defaultMessage: 'File removed. We keep the files of the 3 newest revisions.',
  },
  fileRemovedSettings: {
    id: 'app.sml.promote.revisions.fileRemovedSettings',
    defaultMessage: 'The settings of r{number} are still here.',
  },
  loadError: { id: 'app.sml.promote.revisions.loadError', defaultMessage: 'We could not load the revisions.' },
  // What changed (design d1).
  factTheme: { id: 'app.sml.promote.revisions.fact.theme', defaultMessage: 'Theme' },
  factStyle: { id: 'app.sml.promote.revisions.fact.style', defaultMessage: 'Style' },
  factText: { id: 'app.sml.promote.revisions.fact.text', defaultMessage: 'Text' },
  factColours: { id: 'app.sml.promote.revisions.fact.colours', defaultMessage: 'Colours' },
  factLength: { id: 'app.sml.promote.revisions.fact.length', defaultMessage: 'Length' },
  factMadeBy: { id: 'app.sml.promote.revisions.fact.madeBy', defaultMessage: 'Made by' },
  coloursChanged: { id: 'app.sml.promote.revisions.coloursChanged', defaultMessage: 'Other colours' },
  // Compare (design d2).
  compareTitle: { id: 'app.sml.promote.revisions.compareTitle', defaultMessage: 'Compare' },
  compareHint: { id: 'app.sml.promote.revisions.compareHint', defaultMessage: 'Pick two revisions with a file.' },
  compareNoFile: { id: 'app.sml.promote.revisions.compareNoFile', defaultMessage: 'No file to compare' },
  comparePlay: { id: 'app.sml.promote.revisions.comparePlay', defaultMessage: 'Play both' },
  comparePause: { id: 'app.sml.promote.revisions.comparePause', defaultMessage: 'Pause both' },
  compareClose: { id: 'app.sml.promote.revisions.compareClose', defaultMessage: 'Close Compare' },
  // Make a new revision (design d3).
  dialogTitle: { id: 'app.sml.promote.revisions.dialog.title', defaultMessage: 'Make a new revision' },
  dialogSub: { id: 'app.sml.promote.revisions.dialog.sub', defaultMessage: '{name} · {title} · this makes r{number}' },
  dialogTheme: { id: 'app.sml.promote.revisions.dialog.theme', defaultMessage: 'Theme' },
  dialogThemeNow: {
    id: 'app.sml.promote.revisions.dialog.themeNow',
    defaultMessage: 'The theme of the song now.',
  },
  dialogThemeNote: {
    id: 'app.sml.promote.revisions.dialog.themeNote',
    defaultMessage: 'Change the theme of the song on the Overview tab. It changes the look of every new asset.',
  },
  dialogStyle: { id: 'app.sml.promote.revisions.dialog.style', defaultMessage: 'Style' },
  dialogWaveform: { id: 'app.sml.promote.revisions.dialog.waveform', defaultMessage: 'Waveform' },
  dialogText: { id: 'app.sml.promote.revisions.dialog.text', defaultMessage: 'Text' },
  costFree: { id: 'app.sml.promote.revisions.cost.free', defaultMessage: 'Free. Images cost no video credits.' },
  costCredits: {
    id: 'app.sml.promote.revisions.cost.credits',
    defaultMessage: '{cost, plural, one {# video credit} other {# video credits}}',
  },
  costLeft: {
    id: 'app.sml.promote.revisions.cost.left',
    defaultMessage: '{left, plural, one {# credit left} other {# credits left}}',
  },
  keepNote: {
    id: 'app.sml.promote.revisions.keepNote',
    defaultMessage: 'We keep the files of the 3 newest revisions.',
  },
  keepNoteLoses: {
    id: 'app.sml.promote.revisions.keepNoteLoses',
    defaultMessage:
      'We keep the files of the 3 newest revisions. After r{next}, the file of r{lost} goes away. Download it first if you need it.',
  },
  moreOptions: { id: 'app.sml.promote.revisions.moreOptions', defaultMessage: 'More options in the Studio' },
  cancel: { id: 'app.sml.promote.revisions.cancel', defaultMessage: 'Cancel' },
  make: { id: 'app.sml.promote.revisions.make', defaultMessage: 'Make r{number}' },
  made: { id: 'app.sml.promote.revisions.made', defaultMessage: 'Making r{number}. It shows on the card at once.' },
});
